<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8i2ui7/tc-custom/9781637152515.jpg?1712805186808" alt="This image is the cover for the book Wrapped Up: The Complete Collection, Wrapped Up: The Complete Collection"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wrapped Up: The Complete Collection, Wrapped Up: The Complete Collection
      </h1>
      <p class="bookDescription body article font2">
        <p>Mummies! Vampires! Kaiju! OH MY! The beloved middle-grade monster sensation—now in one complete volume from creators Dave Scheidt (Mayor Good Boy) and Scoot McMahon (Sami the Samurai Squirrel)! Milo is just your average twelve-year-old boy. His loving parents are mummies, his best friend is an old wizard, and his babysitters are witches. When Milo isn't busy at school or visiting the comic book store, he loves to hang out with cool teen vampires, play with magical kitties, feed a hungry kaiju, and avoid a love-crazed gorilla at all costs. You know, typical kid stuff!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dave Scheidt, Scoot McMahon, Sean Dove
      </h2>
      
      <p class="authorDescription body article">Dave Scheidt is a writer from Chicago, Illinois. When he’s not writing comic books, he likes watching monster movies and eating snacks. He first started writing stories when he was ten years old and hasn’t stopped since. He’s the co-creator of Mayor Good Boy along with Miranda Harmon and Agents of SLAM with Scoot McMahon.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Oni Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?229364a0